import { translations } from "@/i18n/translations";

const LEGACY_SUBTITLES = {
  ro: new Set([
    "Numere care confirmă strategia.",
    "Rezultate măsurabile",
  ]),
  en: new Set([
    "Numbers that confirm the strategy.",
    "Measurable results",
  ]),
};

export function isLegacyStatsItem(item) {
  if (!item || typeof item !== "object") return false;
  if (typeof item.title === "string" && item.title.trim()) return false;
  return item.value != null || item.label != null;
}

export function isLegacyStatsBlock(stats) {
  if (!stats || typeof stats !== "object") return false;
  if (!Array.isArray(stats.items)) return false;
  return stats.items.some(isLegacyStatsItem);
}

/** Normalize stats block to the current Why Us shape (title + desc cards). */
export function migrateStatsBlock(stats, lang) {
  const defaults = translations[lang]?.stats || {};
  const base = stats && typeof stats === "object" ? { ...stats } : {};
  const defaultItems = Array.isArray(defaults.items) ? defaults.items : [];

  if (!isLegacyStatsBlock(base)) {
    return {
      ...base,
      subtitle: base.subtitle || defaults.subtitle || "",
      items: Array.isArray(base.items)
        ? base.items.map((item, index) => ({
            title: String(item?.title ?? defaultItems[index]?.title ?? ""),
            desc: String(item?.desc ?? defaultItems[index]?.desc ?? ""),
          }))
        : defaultItems,
    };
  }

  const items = defaultItems.map((def, index) => {
    const saved = base.items?.[index];
    if (saved?.title) {
      return {
        title: String(saved.title),
        desc: String(saved.desc ?? def.desc ?? ""),
      };
    }
    return {
      title: String(def.title ?? ""),
      desc: String(def.desc ?? ""),
    };
  });

  let subtitle = base.subtitle;
  if (!subtitle || LEGACY_SUBTITLES[lang]?.has(subtitle)) {
    subtitle = defaults.subtitle || subtitle || "";
  }

  return {
    subtitle,
    items,
  };
}

export function migrateLangStats(langSlice, lang) {
  if (!langSlice || typeof langSlice !== "object") return langSlice;
  if (!langSlice.stats) return langSlice;

  const migrated = migrateStatsBlock(langSlice.stats, lang);
  const next = { ...langSlice, stats: migrated };
  delete next.stats.title;
  delete next.stats.description;
  return next;
}

export function migratePayloadStats(payload) {
  if (!payload || typeof payload !== "object") return payload;
  return {
    ...payload,
    ro: migrateLangStats(payload.ro, "ro"),
    en: migrateLangStats(payload.en, "en"),
  };
}

export function normalizeStatsListForEditor(items, lang) {
  if (!Array.isArray(items)) return [];
  const defaults = translations[lang]?.stats?.items || [];

  return items.map((item, index) => {
    const def = defaults[index] || { title: "", desc: "" };
    if (isLegacyStatsItem(item)) {
      return { title: def.title, desc: def.desc };
    }
    return {
      title: String(item?.title ?? def.title ?? ""),
      desc: String(item?.desc ?? def.desc ?? ""),
    };
  });
}
